module.exports = __webpack_public_path__ + "img/grayscale.ba8ed99c.jpeg";